angular.module('lsnBase')
  .config([function() {
    if(!Number.isInteger) {
      Number.isInteger = function(value){
        return parseInt(value, 10) === value;
      };
    }
  }]);